import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, ShoppingBag, Package, Tag, Settings, Truck, PlusCircle, BarChart3, LogOut, Loader2, Image } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/commandes", label: "Réservations", icon: ShoppingBag },
  { to: "/admin/tournees", label: "Livraisons", icon: Truck },
  { to: "/admin/nouvelle-commande", label: "Nouvelle réservation", icon: PlusCircle },
  { to: "/admin/produits", label: "Produits", icon: Package },
  { to: "/admin/galerie", label: "Galerie", icon: Image },
  { to: "/admin/promos", label: "Codes promo", icon: Tag },
  { to: "/admin/trafic", label: "Trafic", icon: BarChart3 },
  { to: "/admin/parametres", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-brand-sage"><Loader2 className="w-8 h-8 animate-spin text-brand-green" /></div>;
  if (user === false) { navigate("/admin/login"); return null; }

  return (
    <div className="min-h-screen flex bg-brand-sage">
      <aside className="w-60 bg-brand-green text-white flex flex-col fixed h-full">
        <div className="p-5 font-serif text-xl font-bold border-b border-white/10"><span className="text-white">Zeit</span><span className="text-brand-gold">rog</span></div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-brand-gold text-brand-green font-semibold" : "text-white/80 hover:bg-white/10"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="admin-logout" onClick={() => { logout(); navigate("/admin/login"); }} className="m-3 flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-white/70 hover:bg-white/10">
          <LogOut className="w-4 h-4" /> Déconnexion
        </button>
      </aside>
      <div className="flex-1 ml-60 p-6 lg:p-10">
        <Outlet />
      </div>
    </div>
  );
}
